// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"624":"b243d21b424ecff6","7360":"3d670102b6a53cab"}[chunkId] + ".css";
};